module.exports = __webpack_public_path__ + "static/media/ic_addUser.d45ddc7c.svg";